'use client';

import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center space-x-2 bg-muted rounded-lg p-1">
      <button
        onClick={() => setLanguage('en')}
        className={`flex items-center space-x-1 px-3 py-1.5 rounded-md transition-all duration-200 ${
          language === 'en' ?'bg-brand-primary text-white shadow-sm' :'text-muted-foreground hover:text-primary'
        }`}
        aria-label="Switch to English"
      >
        <span className="text-lg">🇬🇧</span>
        <span className="text-xs font-semibold">EN</span>
      </button>
      
      <button
        onClick={() => setLanguage('ar')}
        className={`flex items-center space-x-1 px-3 py-1.5 rounded-md transition-all duration-200 ${
          language === 'ar' ?'bg-brand-primary text-white shadow-sm' :'text-muted-foreground hover:text-primary'
        }`}
        aria-label="Switch to Arabic"
      >
        <span className="text-lg">🇸🇦</span>
        <span className="text-xs font-semibold">AR</span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;